<template>
  <v-dialog v-model="showModal" width="400" @click:outside=closeDialog>
      <v-card max-width="400">
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="text-h5 text-medium-emphasis ps-2 title-text" >add category tag</div>
          <v-btn icon="mdi-close" variant="text" @click=closeDialog></v-btn>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-sheet class="mx-auto" width="300">
            <v-form @submit.prevent ref="form">
              <v-select
                label="select broad"
                :items="broads"
                item-title="name"
                item-value="id"
                v-model="broad_id"
                :rules="[required]"
              ></v-select>
              <v-text-field v-model="name" id="name" :rules="[required]" label="name" variant="underlined" class="form_field"></v-text-field>
              <v-select
                label="select parent tag"
                :items="filteredTagsByBroad"
                item-title="name"
                item-value="id"
                v-model="parent_tag_id"
              ></v-select>
            </v-form>
          </v-sheet>
        </v-card-text>
        <template v-slot:actions>
          <v-btn v-on:click="submitForm" class="mt-2 submit_button" type="submit" block>Submit</v-btn>
        </template>
      </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';

export default {
  props: {
    show: Boolean,
    tags: [],
  },
  data() {
    return {
      broads: [],
      broad_id: '', // the selected broad_id
      name: '',
      parent_tag_id: '', // the selected parent_tag_id
      
    }
  },
  async created() {
    this.getBroads();
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    showModal: {
      get () {
        return this.show
      }
    },
    filteredTagsByBroad() {
      // Return all tags if no broad is selected
      if (!this.broad_id) {
        return this.tags;
      }
      // Filter tags based on selected type
      return this.tags.filter((tag) => tag.broad_id === this.broad_id);
    },

  },
  methods: {
      ...mapMutations(["showSnackbar"]), 
    async submitForm(e) {
      e.preventDefault();
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      try {
        
        await axios.request({
          url: "/securities/categorisations/config/tag",
          method: "POST",
          headers: {
              Authorization: `Bearer ${this.token}`
          },
          data: {
            broad_id: this.broad_id,
            name: this.name,
            parent_tag_id: this.parent_tag_id
          }
        });
          this.resetDataValues(); // clear form field values
          this.$parent.getTags(); // update list on local view
          this.$emit("close"); // close modal via parent
      } catch (error) {
        this.showSnackbar({ message: 'Failed to create tag' });
      }
    },
    async getBroads(){
      try {
      const response  = await axios.get("/securities/categorisations/config/broads",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
        this.broads = response.data;
      
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load broad categories' });
      }
    },
    resetDataValues(){
      this.name = "";
    },
    closeDialog(){
      this.resetDataValues();
      this.$emit('close');
    },
    required (v) {
        return (v !== null && v !== undefined && v !== '') || 'required'
    },
  } 
}
</script>

<style scoped>

.title-text, .body-text, .form_field, .submit_button {
  font-family: "Space Grotesk", "Courier New", Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>